import { ErrorBoundary } from '@sentry/react';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { defaultSeasonsAtom } from '@/atoms/filters/highLevel/seasons';
import { tableColumnsAtom } from '@/atoms/queries/tableColumns';
import { teamGameAggsAtom } from '@/atoms/queries/team/teamGameAggData';
import { teamMetricsAtom } from '@/atoms/queries/team/teamRadar';
import { unwrappedVisibleTableColumnsAtom } from '@/atoms/table';
import { GeneralErrorBoundaryFallback } from '@/components/errorBoundary/ErrorBoundaryFallback';
import { GameAggregatesTable } from '@/components/tables/GameAggregatesTable';
import { TEAM_GAMES_DEFAULT_COLUMNS } from '@/components/tables/GameAggregatesTable.constants';

const TeamGameAggsTableWithData = () => {
  const data = useAtomValue(teamGameAggsAtom);
  const hasDefaultSeason = useAtomValue(defaultSeasonsAtom);
  const tableColumns = useAtomValue(tableColumnsAtom);
  const visibleColumns = useAtomValue(unwrappedVisibleTableColumnsAtom);
  const teamMetricData = useAtomValue(teamMetricsAtom);

  return (
    <GameAggregatesTable
      data={data}
      visibleColumns={visibleColumns}
      availableColumns={tableColumns}
      isLoading={!hasDefaultSeason}
      metricData={teamMetricData}
    />
  );
};

export const TeamGameAggsTable = () => (
  <ErrorBoundary fallback={<GeneralErrorBoundaryFallback />}>
    <Suspense fallback={<GameAggregatesTable isLoading visibleColumns={[...TEAM_GAMES_DEFAULT_COLUMNS]} />}>
      <TeamGameAggsTableWithData />
    </Suspense>
  </ErrorBoundary>
);
